var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-tooltip',{attrs:{"label":_vm.tip,"position":_vm.position,"multilined":""}},[_c('icon-default',{staticStyle:{"cursor":"help"},attrs:{"icon":"info","size":_vm.size,"color":"is-light"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }